import styled from 'styled-components';

import Link from 'components/link';
import LoyaltyClaimPointsLink from 'pages/loyalty/loyalty-claim-points/loyalty-claim-points-link';
import { TableWrap as DefaultTableWrap } from 'pages/loyalty/loyalty-history/loyalty-history.styled';

import { DASHBOARD_PADDING_SIZE } from '../../loyalty-dashboard/constants';

export const Container = styled.div`
  background-color: ${Styles.color.white};
  width: calc(100% + ${DASHBOARD_PADDING_SIZE} + ${DASHBOARD_PADDING_SIZE});
  margin-left: -${DASHBOARD_PADDING_SIZE};
  margin-top: 1rem;
  padding: 0 ${DASHBOARD_PADDING_SIZE} 50px;

  ${Styles.desktop`
    border-radius: ${Styles.borderRadius} ${Styles.borderRadius} 0 0;
    width: 100%;
    margin-left: 0;
  `}
`;

export const Header = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  margin: 0;
`;

export const SubText = styled(Link)`
  margin-bottom: 1rem;
  text-decoration: underline;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const TableWrap = styled(DefaultTableWrap)`
  max-width: 620px;
`;

export const StyledLoyaltyClaimPointsLink = styled(LoyaltyClaimPointsLink)`
  margin-top: 1rem;
`;
